/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/footer.config.json";

export interface IFooterMethods extends IPluginMethodMap {
  getFooterProps(args: any): Promise<any>;
}

export class FooterService implements IAgentPlugin {
  readonly methods: IFooterMethods;

  constructor() {
    this.methods = {
      getFooterProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    return { ...(config || {}) };
  }
}
